export default __webpack_public_path__ + "static/computer-image-76139dfeee8a6c85ebda168a1ba775b9.png";